import { TSubmitPlacesParams } from '../../../types/services';
import { asyncTimeout } from '../../../utils/asyncTimeout';
import { SERVICES_MOCK_DELAY } from '../../../utils/constants';

export const submitPlaces = async (
  params: TSubmitPlacesParams
): Promise<void> => {
  await asyncTimeout(SERVICES_MOCK_DELAY);
};
